interface StatusIconType {
    [key: string]: {
        icon: string
        color?: string
    }
}

export const tabList = [
    // {
    //     icon: "technical",
    //     key: "technical",
    //     label: "common.labels.technicals",
    //     url: "/register/technical",
    // },
    {
        icon: "company",
        key: "company",
        label: "common.labels.companies",
        url: "/register/company",
    },
    {
        icon: "laboratory",
        key: "laboratory",
        label: "common.labels.laboratories",
        url: "/register/laboratory",
    },
    {
        icon: "samples",
        key: "sample",
        label: "common.labels.samples",
        url: "/register/sample",
    },
    {
        icon: "equipment",
        key: "equipment",
        label: "common.labels.equipments",
        url: "/register/equipment",
    },
    {
        icon: "document",
        key: "form",
        label: "common.labels.forms",
        url: "/register/form"
    },
    {
        icon: "method",
        key: "method",
        label: "common.labels.method_group",
        url: "/register/method"
    },
    // {
    //     icon: "form",
    //     key: "report",
    //     label: "common.labels.reports",
    //     url: "/register/report"
    // },
];

export const statusIcons: StatusIconType = {
    PENDING: {
        icon: "time",
    },
    STARTED: {
        icon: "time-b",
    },
    PAUSED: {
        icon: "pause",
    },
    CANCELED: {
        icon: "info",
        color: "#ff0000"
    },
    CONCLUDED: {
        icon: "confirmed",
        color: "green"
    },
};

export const orderIcons: StatusIconType = {
    await: {
        icon: "order-checked",
        color: "green"
    },
    concluded: {
        icon: "order-await",
        color: "#D44E1E"
    },
};